import { injectReducers } from '@driftt/traffic-control'
import classnames from 'classnames'
import { path } from 'ramda'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { createPlaybookFormattedBlock } from 'api/blocks'
import { APP_PAGE_TITLES } from 'constants/pageTitles'
import useDocumentTitle from 'hooks/usePageTitle'
import ContentViewLayout from 'layouts/ContentViewLayout'
import { BOT_FLOW_MODES } from 'modules/editor/reducer'
import { isFastLanePlaybook } from 'utils/playbooks'

import './style.css'

const BotEditor = ({
  playbook,
  classifications,
  onChange,
  onCreateExperiment,
  isAIEnabled,
  onTransientChange,
  location,
  history,
  title,
}) => {
  const [magnusLoadReady, setMagnusLoadReady] = useState(false)
  const [MagnusMod, setMagnusMod] = useState(null)
  const [initialRender, setInitialRender] = useState(false)
  const [loaded, setLoaded] = useState(false)

  const botFlowMode = useSelector(
    path(['__PLAYBOOK_EDITOR', 'editor', 'botFlowMode'])
  )

  const playbookId = useSelector(path(['__PLAYBOOK_EDITOR', 'playbook', 'id']))

  // that's a big four-oh-four
  if (location.pathname.endsWith('experiment') && !playbook) {
    history.push(location.pathname.replace('/experiment', ''))
  }

  const isExperimentEditorActive = location.pathname.endsWith(
    'visual-builder/experiment'
  )
  const pageTitle = isFastLanePlaybook(playbook)
    ? APP_PAGE_TITLES.FASTLANE
    : APP_PAGE_TITLES.PLAYBOOK

  useDocumentTitle(pageTitle)
  useEffect(() => {
    !MagnusMod &&
      import('@driftt/magnus').then((mod) => {
        injectReducers(mod.MagnusRootReducer)
        setMagnusMod(mod.Magnus)
      })

    MagnusMod && setMagnusLoadReady(true)
    MagnusMod && setTimeout(() => setInitialRender(true), 0)
  }, [MagnusMod])

  useEffect(() => {
    initialRender && setTimeout(() => setLoaded(true), 0)
  }, [initialRender])

  if (
    !playbook ||
    !classifications ||
    !magnusLoadReady ||
    !MagnusMod ||
    !initialRender
  ) {
    return null
  }

  if (botFlowMode === BOT_FLOW_MODES.CONTENT_VIEW) {
    return (
      <ContentViewLayout
        pbId={playbookId}
        isExperiment={isExperimentEditorActive}
      />
    )
  }

  return (
    <MagnusMod
      className={classnames('playbook-context-bot', {
        'pew-magnus-loaded': loaded,
      })}
      title={title}
      playbook={playbook}
      classifications={classifications}
      onChange={onChange}
      onCreateExperiment={onCreateExperiment}
      onTransientChange={onTransientChange}
      isAIEnabled={isAIEnabled}
      createBlock={createPlaybookFormattedBlock}
    />
  )
}

export default withRouter(BotEditor)
